import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { LoginEmailResponseDto } from "../../dtos/login-email-response-dto";
import type { VerifyOtpRequestDto } from "../../dtos/verify-otp-request-dto";
import { AuthService } from "../../services/auth-service";

type UsePostVerifyOtpMutationProps = {
  options?: UseMutationOptions<
    LoginEmailResponseDto,
    unknown,
    VerifyOtpRequestDto & {
      page: "register" | "login";
    }
  >;
};

export const usePostVerifyOtpMutation = ({
  options
}: UsePostVerifyOtpMutationProps = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return AuthService.verifyOtp({ payload });
    },
    ...options
  });
};
